import {
  BoldCellTextStyled,
  DetailBoxStyled,
  DetailPillStyled,
  NetworkDetailSmall,
} from './PlanDetailsTableStyled';

interface PlanDetailsCellProps {
  detailLabel: string;
  detailValue?: string;
  align?: string;
  isMobile?: boolean;
}

export const PlanDetailsCell = ({
  detailLabel,
  detailValue,
  align,
  isMobile = false,
}: PlanDetailsCellProps) => {
  return (
    <DetailBoxStyled sx={{ alignItems: align }} className="col-4">
      <NetworkDetailSmall>
        {isMobile ? (
          <>
            <DetailPillStyled>{detailLabel}</DetailPillStyled>
            <BoldCellTextStyled>{detailValue || '-'}</BoldCellTextStyled>
          </>
        ) : (
          <>
            <BoldCellTextStyled>{detailValue || '-'}</BoldCellTextStyled>
            <DetailPillStyled>{detailLabel}</DetailPillStyled>
          </>
        )}
      </NetworkDetailSmall>
    </DetailBoxStyled>
  );
};
